module.exports = __webpack_public_path__ + "static/img/img-6.c00d0db.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/img/img-6.png
// module id = 9reR
// module chunks = 1